module.exports = __webpack_public_path__ + "img/new_fengexian.789b67dd.png";